import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getCredits(params: any): AxiosPromise {
    return EndPointService.get('/payment_credits', { params });
}
function getCredit(id: number | string): AxiosPromise {
    return EndPointService.get(`/payment_credits/${id}`);
}

function deleteCredit(id: number | string): AxiosPromise {
    return EndPointService.delete(`/payment_credits/${id}`);
}

function createCredit(payload: any): AxiosPromise {
    return EndPointService.post('/payment_credits/create', payload);
}

function updateCredit(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/payment_credits/${id}`, payload, { params: { id } });
}

function patchCredit(payload: any): AxiosPromise {
    return EndPointService.put(`/payment_credits/status`, payload);
}

export default {
    getCredits,
    getCredit,
    deleteCredit,
    createCredit,
    updateCredit,
    patchCredit,
};
